export default __webpack_public_path__ + "static/media/uploader-trivia-problem-2.37c9f6dd.png";